import { Container } from 'reactstrap';
import styled, { css } from 'styled-components';

import { NAV_HEIGHT } from 'src/consts';
import type { ThemeColorType, ThemeSpaceType } from 'src/styles/theme';

export const SectionContainer = styled(Container)<{ color: ThemeColorType; spacing: ThemeSpaceType }>`
  overflow: hidden;
  background-color: ${props => (props.color ? props.theme.colors[props.color] : props.theme.colors.white)};
  min-height: ${props => (props.full ? `calc(100vh - ${NAV_HEIGHT}px)` : 'initial')};
  min-width: 100%;
  padding: ${props => (props.isHero ? props.theme.space.s5 : props.theme.space.s8)} ${props => props.theme.space.s5} 0;
  position: relative;

  ${props => props.theme.mediaQueries.small} {
    padding: ${props => (props.spacing ? props.theme.space[props.spacing] : props.theme.space.s9)}
      ${props => props.theme.space.s10} 0;
    ${props =>
      props.isHero &&
      css`
        padding: ${props => props.theme.space.s7} ${props => props.theme.space.s10} 0;
      `}
  }
`;
